import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import Pagination from "../../../components/Pagination";
import Table from "../../../components/table";
import usePagination from "../../../components/usePagination";
import api from "../../../api/api";
import * as bootstrap from "bootstrap";
import "../../Freight/Common/form.css";
import BackButton from "../../../components/BackButton";
import SearchIcon from "@mui/icons-material/Search";

const SpecialEnquiries = () => {
  const location = useLocation();
  const { fromDate, toDate, createdBy } = location.state || {};

  console.log('SpecialEnquiries - Received filters:', { fromDate, toDate, createdBy });
  
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  
  /* ================= FETCH SPECIAL ENQUIRIES ================= */
  useEffect(() => {
    const fetchEnquiries = async () => {
      setLoading(true);
      console.log('Fetching special enquiries with params:', { fromDate, toDate, createdBy });
      try {
        const params = {};
        if (fromDate) params.fromDate = fromDate;
        if (toDate) params.toDate = toDate;
        if (createdBy) params.CreateBY = createdBy;
        console.log('API params:', params);

        const response = await api.get("/sales/special-enquiries", { params });
        console.log('API response:', response.data);

        const enquiriesData = (response.data.specialEnquiries || []).map((c) => ({
          ...c,
          follow_up_number: parseInt(c.follow_up_number) || 0,
        }));

        setEnquiries(enquiriesData);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch special enquiries");
      } finally {
        setLoading(false);
      }
    };
  
    fetchEnquiries();
  }, [fromDate, toDate, createdBy]);
  
  /* ================= SEARCH FILTER ================= */
  const filteredEnquiries = enquiries.filter((enquiry) => {
    const term = search.toLowerCase();

    return (
      enquiry.customer_name?.toLowerCase().includes(term) ||
      enquiry.company_name?.toLowerCase().includes(term)
    );
  });
  
  /* ================= PAGINATION ================= */
  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(filteredEnquiries, 5);

  /* ================= TOOLTIP ================= */
  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((el) => new bootstrap.Tooltip(el));
  }, [filteredEnquiries, currentPage]);
  
  if (error) return <p className="text-danger">{error}</p>;
  
  /* ================= TABLE COLUMNS ================= */
  const columns = [
    {
      label: "Customer Name",
      render: (enquiry) => (
        <span
          data-bs-toggle="tooltip"
          title={enquiry.customer_name}
        >
          {enquiry.customer_name}
        </span>
      ),
    },
    {
      label: "Company Name",
      render: (enquiry) => (
        <span data-bs-toggle="tooltip" title={enquiry.company_name}>
          {enquiry.company_name}
        </span>
      ),
    },
    {
      label: "Order Segment From",
      render: (enquiry) => (
        <span data-bs-toggle="tooltip" title={enquiry.order_segment_from}>
          {enquiry.order_segment_from}
        </span>
      ),
    },
    {
      label: "Order Segment To",
      render: (enquiry) => (
        <span data-bs-toggle="tooltip" title={enquiry.order_segment_to}>
          {enquiry.order_segment_to}
        </span>
      ),
    },
    {
      label: "Handled By",
      render: (enquiry) => (
        <span data-bs-toggle="tooltip" title={enquiry.handled_by}>
          {enquiry.handled_by || "-"}
        </span>
      ),
    },
    {
      label: "Date",
      render: (enquiry) => {
        // Parse the date string directly without timezone conversion
        const dateStr = enquiry.created_at.split('T')[0];
        const timePart = enquiry.created_at.split('T')[1]?.split('.')[0] || '';
        const [hours, minutes] = timePart.split(':') || [];
        const hour = parseInt(hours, 10);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const hour12 = hour % 12 || 12;
        return `${dateStr} ${hour12}:${minutes} ${ampm}`;
      },
    },
  ];
  
  /* ================= RENDER ================= */
  return (
    <>
      <BackButton />
  
        {/* SEARCH INPUT */}
      <div className="mb-3 position-relative" style={{ maxWidth: "100%" }}>
        <input
          type="search"
          className="form-control ps-5"
          placeholder="Search by Client Name or Company Name..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
 
        <SearchIcon
          style={{
            position: "absolute",
            left: "12px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#6b7280",
            width:"16px",
            height:"16px"
          }}
        />
      </div>
  
      {/* TABLE */}
      <Table
        columns={columns}
        data={currentItems}
        loading={loading}
        emptyMessage="No Special Enquiries found."
        itemsPerPage={itemsPerPage}
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            totalItems={totalItems}
          />
        }
      />
    </>
  );
};

export default SpecialEnquiries;
